import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuthWrapper } from "../pages/RequireAuthWrapper";
import { PublisherHomePage } from "../pages/publisherHomePage";
import { UrlList } from "../pages/humanInTheLoopPage/urlList";
import { UrlReview } from "../pages/humanInTheLoopPage/urlReview";
import { PastReview } from "../pages/humanInTheLoopPage/pastReview";
import { PredictiveCorrection } from "../pages/humanInTheLoopPage/predictiveCorrections/index";
import { HumanInTheLoop } from "../pages/humanInTheLoopPage";
import { SegmentHomePage } from "../pages/segmentHomePage";
import { SegmentSetupPage } from "../pages/segmentSetupPage";
import { SegmentSummaryPage } from "../pages/segmentSummaryPage";
import { PermissionsWrapper } from "../pages/PermissionsWrapper";
import { GamCampaignHomePage } from "../pages/gamCampaignHomePage";
import { GamCampaignSummaryPage } from "../pages/gamCampaignSummaryPage";
import { GamCampaignSetupPage } from "../pages/gamCampaignSetupPage";
import { hitlPredictionsAccess, humanInTheLoopAccess } from "../utils/accessControls";

export const PublisherRoutes = () => {
  return (
    <Routes>
      <Route path={""}>
        <Route
          path={""}
          element={
            <RequireAuthWrapper>
              <PublisherHomePage />
            </RequireAuthWrapper>
          }
        >
          <Route
            path={""}
            element={<Navigate to={"segments"} replace={true} />}
          />
          <Route path={"segments"}>
            <Route
              path={""}
              element={
                <RequireAuthWrapper>
                  <PermissionsWrapper agencyPartnerCheck={true}>
                    <SegmentHomePage />
                  </PermissionsWrapper>
                </RequireAuthWrapper>
              }
            />
            <Route
              path={"new"}
              element={
                <RequireAuthWrapper>
                  <PermissionsWrapper agencyPartnerCheck={true}>
                    <SegmentSetupPage />
                  </PermissionsWrapper>
                </RequireAuthWrapper>
              }
            />
            <Route path={":id"}>
              <Route
                path={""}
                element={
                  <RequireAuthWrapper>
                    <PermissionsWrapper agencyPartnerCheck={true}>
                      <SegmentSummaryPage />
                    </PermissionsWrapper>
                  </RequireAuthWrapper>
                }
              />
            </Route>
          </Route>

          <Route path={"campaigns"}>
            <Route
              path={""}
              element={
                <RequireAuthWrapper>
                  <PermissionsWrapper
                    agencyPartnerCheck={true}
                    allowedPartners={[]}
                  >
                    <GamCampaignHomePage />
                  </PermissionsWrapper>
                </RequireAuthWrapper>
              }
            />
            <Route
              path={"new"}
              element={
                <RequireAuthWrapper>
                  <PermissionsWrapper
                    agencyPartnerCheck={true}
                    allowedPartners={[]}
                  >
                    <GamCampaignSetupPage />
                  </PermissionsWrapper>
                </RequireAuthWrapper>
              }
            />
            <Route path={":id"}>
              <Route
                path={""}
                element={
                  <RequireAuthWrapper>
                    <PermissionsWrapper
                      agencyPartnerCheck={true}
                      allowedPartners={[]}
                    >
                      <GamCampaignSummaryPage />
                    </PermissionsWrapper>
                  </RequireAuthWrapper>
                }
              />
            </Route>
          </Route>

          <Route
            path={"human-in-the-loop"}
            element={
              <RequireAuthWrapper>
                <PermissionsWrapper
                  agencyPartnerCheck={true}
                  allowedPartners={humanInTheLoopAccess}
                >
                  <HumanInTheLoop />
                </PermissionsWrapper>
              </RequireAuthWrapper>
            }
          >
            <Route
              path={""}
              element={<Navigate to={"url-list"} replace={true} />}
            />

            <Route
              path={"url-list"}
              element={
                <RequireAuthWrapper>
                  <UrlList />
                </RequireAuthWrapper>
              }
            />
            <Route path={":url"}>
              <Route
                path={"review"}
                element={
                  <RequireAuthWrapper>
                    <UrlReview />
                  </RequireAuthWrapper>
                }
              />

              <Route
                path={"past-review"}
                element={
                  <RequireAuthWrapper>
                    <PastReview />
                  </RequireAuthWrapper>
                }
              />

              <Route
                path={"predictive-correction"}
                element={
                  <RequireAuthWrapper>
                    <PermissionsWrapper
                      agencyPartnerCheck={true}
                      allowedPartners={hitlPredictionsAccess}
                    >
                      <PredictiveCorrection />
                    </PermissionsWrapper>
                  </RequireAuthWrapper>
                }
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
